module.exports = __webpack_public_path__ + "static/media/6D.2e30ef88.svg";